<template>
  <div>
    <v-navigation-drawer
      clipped
      v-model="sidebar"
      app
      :style="{ top: $vuetify.application.top + 'px', zIndex: 4 }"
    >
      <v-list>
        <v-list-item-group>
          <!-- <v-list-item>
            <v-list-item-title>
              <div @click="changeClicked('pendanaan')">
                <span
                  v-if="clicked != 'pendanaan' && $route.name != 'Pendanaan'"
                  class="navText"
                >
                  Pendanaan
                </span>
                <span v-else class="navTextActive">
                  Pendanaan
                </span>
              </div>
            </v-list-item-title>
          </v-list-item> -->

          <!-- <v-list-item>
            <v-list-item-title>
              <div @click="changeClicked('pinjaman')">
                <span
                  v-if="clicked != 'pinjaman' && $route.name != 'Pinjaman'"
                  class="navText"
                >
                  Pinjaman
                </span>
                <span v-else class="navTextActive">
                  Pinjaman
                </span>
              </div>
            </v-list-item-title>
          </v-list-item> -->

          <!-- <v-list-item>
            <v-list-item-title>
              <div @click="changeClicked('produk')">
                <span
                  v-if="clicked != 'produk' && $route.name != 'Produk'"
                  class="navText"
                >
                  Produk
                </span>
                <span v-else class="navTextActive">
                  Produk
                </span>
              </div>
            </v-list-item-title>
          </v-list-item> -->

          <v-list-item>
            <v-list-item-title>
              <div @click="changeClicked('tentang-kami')">
                <span
                  v-if="
                    clicked != 'tentang-kami' && $route.name != 'Tentang Kami'
                  "
                  class="navText"
                >
                  Tentang Kami
                </span>
                <span v-else class="navTextActive">
                  Tentang Kami
                </span>
              </div>
            </v-list-item-title>
          </v-list-item>

          <!-- <v-list-item>
            <v-list-item-title>
              <div @click="changeClicked('career')">
                <span
                  v-if="clicked != 'career' && $route.name != 'Karir'"
                  class="navText"
                >
                  Karir
                </span>
                <span v-else class="navTextActive">
                  Karir
                </span>
              </div>
            </v-list-item-title>
          </v-list-item> -->

          <v-list-item>
            <v-list-item-title>
              <div @click="changeClicked('hubungi-kami')">
                <span
                  v-if="
                    clicked != 'hubungi-kami' && $route.name != 'Hubungi Kami'
                  "
                  class="navText"
                >
                  Hubungi Kami
                </span>
                <span v-else class="navTextActive">
                  Hubungi Kami
                </span>
              </div>
            </v-list-item-title>
          </v-list-item>

          <!-- <v-list-item>
            <v-list-item-title>
              <div @click="toBlog">
                <span class="navText">
                  Blog
                </span>
              </div>
            </v-list-item-title>
          </v-list-item> -->
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      clipped-left
      app
      style="border-top: 2px solid #d3352c !important"
    >
      <v-app-bar-nav-icon @click="sidebar = !sidebar">
        <v-icon v-if="sidebar">mdi-close</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-items style="padding-top: 1.25rem;">
        <span class="pl-3" @click="$router.push('/')">
          <img
            style="width: 100%;"
            :src="require('../../assets/dompetkilat.png')"
            alt="John"
          />
        </span>
        <span class="pl-4">
          <img
            style="width: 100%;"
            :src="require('../../assets/homepage/ojk.png')"
            alt="John"
          />
        </span>
        <span class="pl-6">
          <div
            style="
                height: 6px;
                object-fit: contain;
                font-size: 10px;
                font-weight: 300;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.21;
                letter-spacing: normal;
                text-align: left;
                color: #252525;
                "
          >
            TKB90:
          </div>
          <div class="pt-1" />
          <div
            v-if="masterData.tkb"
            style="
                height: 7.3px;

                object-fit: contain;
                font-size: 12px;
                font-weight: 800;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.21;
                letter-spacing: normal;
                text-align: left;
                color: #3bb54a;
                "
          >
            {{ masterData.tkb }}%
          </div>
          <div
            v-else
            style="
                height: 7.3px;

                object-fit: contain;
                font-size: 12px;
                font-weight: 800;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.21;
                letter-spacing: normal;
                text-align: left;
                color: #3bb54a;
                "
          >
            99.63%
          </div>
        </span>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: () => ({
    sidebar: false,
    clicked: "",
  }),
  computed: {
    masterData() {
      return this.$store.state.masterData;
    },
  },
  methods: {
    changeClicked(str) {
      this.clicked = str;
      this.$router.push("/" + str);
    },
    // toBlog() {
    //   window.location = "https://blog.dompetkilat.co.id/";
    // },
  },
};
</script>

<style>
.navTextActive {
  text-decoration: none;
  color: #252525;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.09px;
}
.navText {
  text-decoration: none;
  color: #767676;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.09px;
}
</style>
